<template>
  <div class="scroll-wrap">
    <!-- <div v-if="loadingMore">加载中</div> -->
    <div v-if="noMore" class="notMore">没有更多了</div>
  </div>
</template>

<script>
/**
 * 底部加载更多
 */
export default {
  name: 'NxLoadMore',
  props: {
    distance: {
      type: Number,
      default: 1,
    },
    noMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      element: null,
    };
  },
  mounted() {
    this.element = document.documentElement;
    window.addEventListener('scroll', this.listenBottomOut, false);
  },
  destroyed() {
    window.removeEventListener('scroll', this.listenBottomOut, false);
  },
  methods: {
    listenBottomOut() {
      if (this.noMore || this.loadingMore) return;
      const scrollTop = this.element.scrollTop || document.body.scrollTop;
      const clientHeight = this.element.clientHeight;
      const scrollHeight = this.element.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - this.distance) {
        this.$emit('arriveBottom');
      }
    },
  },
};
</script>
<style scoped>
.notMore{
  width: 100%;
  text-align: center;
  color: rgb(194, 194, 194);
}
</style>
